var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 13.0887C25.9573 20.3766 20.1465 26.104 12.7769 25.9986C6.08263 25.9058 0.00851422 20.7098 1.89558e-05 13.0381C-0.0127239 5.13864 6.4012 -0.107969 13.3546 0.0016866C20.3292 0.111342 26.0422 5.97371 25.9998 13.0887ZM18.9614 18.9384C15.7545 14.9528 15.7247 11.0727 18.9317 7.10402C14.9219 10.2967 11.0651 10.225 7.08507 7.09558C10.2793 11.0769 10.3005 14.9318 7.10206 18.93C11.0948 15.6867 14.9729 15.7837 18.9614 18.9384Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/LogoSmall.f62ab90ebd80a33b756b0f3744f602d5.svg";
export { ForwardRef as ReactComponent };